import { render, staticRenderFns } from "./RetrCurrentSingleTable.vue?vue&type=template&id=64197974"
import script from "./RetrCurrentSingleTable.vue?vue&type=script&lang=js"
export * from "./RetrCurrentSingleTable.vue?vue&type=script&lang=js"
import style0 from "./RetrCurrentSingleTable.vue?vue&type=style&index=0&id=64197974&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports